// | Logic for editing Maps.
import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Data$dValidation$dSemigroup from "../Data.Validation.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Partial from "../Partial/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dForm$dTotality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic$dForm$dValue from "../Restaumatic.Form.Value/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dList from "../Specular.FRP.List/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
const Item = x => x;
const Mapping = x => x;
const queryItem1 = dictQuery => ({queryImpl: v => dictQuery.queryImpl(v.subform)});
const queryArrayTupleMapping = dictOrd => dictQuery => (
  {
    queryImpl: v => {
      const $0 = Specular$dFRP$dBase.bindDynamic.bind(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => ({items: v1, keys_: v2}))(v.items._1))(Specular$dFRP$dBase.bindDynamic.bind(v.keys._1)(x => x)))(v1 => {
        const $0 = v1.items;
        return Specular$dFRP$dBase.functorDynamic.map((() => {
          const $1 = Data$dTraversable.traversableArray.traverse(Restaumatic$dForm$dResult.applicativeResult)(x => x);
          return x => Restaumatic$dForm$dResult.functorResult.map(Data$dArray.catMaybes)($1(x));
        })())(Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic)(k => {
          const v2 = Data$dMap$dInternal.lookup(dictOrd)(k)($0);
          if (v2.tag === "Just") {
            return Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v3 => v4 => {
              if (v3) {
                return Restaumatic$dForm$dResult.functorResult.map((() => {
                  const $1 = Data$dTuple.Tuple(k);
                  return x => Data$dMaybe.$Maybe("Just", $1(x));
                })())(v4);
              }
              return Restaumatic$dForm$dResult.$Result(Data$dMap$dInternal.Leaf, Restaumatic$dForm$dValue.$Value("SomeValue", Data$dMaybe.Nothing));
            })(Specular$dFRP$dBase.bindDynamic.bind(v2._1.presentWhen._1)(x => x)))(dictQuery.queryImpl(v2._1.subform));
          }
          if (v2.tag === "Nothing") {
            const $1 = Restaumatic$dForm$dResult.$Result(
              Data$dMap$dInternal.unionWith(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dFunction.const)(Data$dMap$dInternal.Leaf)(Data$dMap$dInternal.$$$Map(
                "Two",
                Data$dMap$dInternal.Leaf,
                Data$dMaybe.Nothing,
                [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: "Mapping key not found", internal: true}],
                Data$dMap$dInternal.Leaf
              )),
              Restaumatic$dForm$dValue.$Value("SomeValue", Data$dMaybe.Nothing)
            );
            return (() => {
              const n = Specular$dInternal$dIncremental.constant($1);
              Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
              return n;
            })();
          }
          $runtime.fail();
        })(v1.keys_));
      });
      return (() => {
        Specular$dInternal$dIncremental$dNode.annotate($0, "query Mapping");
        return $0;
      })();
    }
  }
);
const queryMapMapping = dictOrd => dictQuery => (
  {
    queryImpl: field => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray)))(queryArrayTupleMapping(dictOrd)(dictQuery).queryImpl(field))
  }
);
const querySerializedMapMapping1 = dictOrd => dictQuery => (
  {
    queryImpl: (() => {
      const $0 = queryMapMapping(dictOrd)(dictQuery).queryImpl;
      return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Unsafe$dCoerce.unsafeCoerce))($0(x));
    })()
  }
);
const queryArrayTupleMapping1 = dictOrd => dictQuery => (
  {
    queryWith: strictness => v => {
      const $0 = Specular$dFRP$dBase.bindDynamic.bind(v.items._1)(items => Specular$dFRP$dBase.bindDynamic.bind(Specular$dFRP$dBase.bindDynamic.bind(v.keys._1)(x => x))(keys_ => Specular$dFRP$dBase.functorDynamic.map((() => {
        const $0 = Data$dTraversable.traversableArray.traverse({
          pure: x => Data$dEither.$Either("Right", x),
          Apply0: () => Data$dValidation$dSemigroup.applyV(Restaumatic$dForm$dFinal.semigroupFormErrors)
        })(x => x);
        return x => {
          const $1 = $0(x);
          if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
          if ($1.tag === "Right") { return Data$dEither.$Either("Right", Data$dArray.mapMaybe(x$1 => x$1)($1._1)); }
          $runtime.fail();
        };
      })())(Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic)(k => {
        const v1 = Data$dMap$dInternal.lookup(dictOrd)(k)(items);
        if (v1.tag === "Just") {
          return Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v2 => v3 => {
            const handleInvalid = strictness.tag === "Lax"
              ? (v2$1 => {
                  if (v2$1.tag === "Left") { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
                  if (v2$1.tag === "Right") { return Data$dEither.$Either("Right", v2$1._1); }
                  $runtime.fail();
                })
              : x => x;
            if (!v2) { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
            if (v2) {
              return handleInvalid((() => {
                if (v3.tag === "Left") { return Data$dEither.$Either("Left", v3._1); }
                if (v3.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(k, v3._1))); }
                $runtime.fail();
              })());
            }
            $runtime.fail();
          })(Specular$dFRP$dBase.bindDynamic.bind(v1._1.presentWhen._1)(x => x)))(dictQuery.queryWith(strictness)(v1._1.subform));
        }
        if (v1.tag === "Nothing") {
          const n = Specular$dInternal$dIncremental.constant(Data$dEither.$Either(
            "Left",
            Data$dMap$dInternal.$$$Map(
              "Two",
              Data$dMap$dInternal.Leaf,
              Data$dMaybe.Nothing,
              [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: "Mapping key not found", internal: true}],
              Data$dMap$dInternal.Leaf
            )
          ));
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        }
        $runtime.fail();
      })(keys_))));
      return (() => {
        Specular$dInternal$dIncremental$dNode.annotate($0, "query Mapping");
        return $0;
      })();
    }
  }
);
const queryMapMapping1 = dictOrd => dictQuery => (
  {
    queryWith: strictness => field => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray)))(queryArrayTupleMapping1(dictOrd)(dictQuery).queryWith(strictness)(field))
  }
);
const initializeSomeInitialValu = dictInitialize => dictMerge => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => {
      const $0 = v.field;
      return Specular$dInternal$dRIO.pureImpl({
        field: $0,
        init: v1 => {
          const $1 = v1._1;
          return initializer => Specular$dInternal$dRIO.bindImpl(v.init(Restaumatic$dForm$dInternal.NoInitialValue)(initializer))(() => dictMerge.merge($1)($0));
        }
      });
    })
  }
);
const initializeNoInitializerMa = dictInitialize => (
  {makeImpl: Restaumatic$dForm$dInternal.makeWithDefaultInitializer(dictInitialize)({item: v => Restaumatic$dForm$dInternal.NoInitializer})}
);
const initializeInitialValueIni = dictMakeWithInitialValueInitializer => ({makeImpl: dictMakeWithInitialValueInitializer.makeWithInitialValueInitializer});
const hasFieldIdMapping = {getFieldId: v => Restaumatic$dForm$dInternal.fieldPathToString(v.name)};
const hasFieldIdItem = dictShow => ({getFieldId: v => Restaumatic$dForm$dInternal.fieldPathToString(v.parent.name) + "." + dictShow.show(v.key)});
const subform = v => v.subform;
const querySerializedMapMapping = dictOrd => dictQuery => (
  {
    queryWith: strictness => {
      const $0 = queryMapMapping1(dictOrd)(dictQuery).queryWith(strictness);
      return x => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dMap$dSerialized.SerializedMap))($0(x));
    }
  }
);
const queryItem = dictQuery => ({queryWith: s => v => dictQuery.queryWith(s)(v.subform)});
const presentWhen = v => v1 => v1.presentWhen._2(_old => v);
const newtypeMapping = {Coercible0: () => {}};
const newtypeItem = {Coercible0: () => {}};
const mergeItem = dictMerge => ({merge: x => v => dictMerge.merge(x)(v.subform)});
const makeItem = dictShow => dictAddContext => v => key1 => {
  const $0 = v.init;
  return () => {
    const init = $0.value;
    const v1 = Specular$dFRP$dHost.runHost(init(v)({name: Data$dSemigroup.concatArray(v.name)([dictShow.show(key1)])})(key1))();
    const ctx = v.context.value;
    dictAddContext.addContext(ctx)(v1._1.subform)();
    return {parent: v1._1.parent, key: v1._1.key, subform: v1._1.subform, cleanup: v1._2, presentWhen: v1._1.presentWhen};
  };
};
const initializeNoInitialValueR = dictAddContext => dictOrd => dictShow => dictInitialize => dictTypeEquals => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMap$dInternal.Leaf))(items => Specular$dInternal$dRIO.bindImpl(() => (
      {value: v => Partial._crashWith("Mapping not fully initialized!")}
    ))(init => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dInternal.make({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost
    })({
      makeImpl: Restaumatic$dForm$dInternal.makeWithInitialValueIniti({
        makeImpl: Restaumatic$dForm$dInternal.makeWithDefaultInitializer(Restaumatic$dForm$dFormField.initializeSomeInitialValu1(Restaumatic$dForm$dTotality.isTotalityPartial)(Type$dEquality.refl)(Type$dEquality.refl))([])
      }).makeWithInitialValueInitializer
    })(v => Restaumatic$dForm$dInternal.$InitialValueInitializer([], Restaumatic$dForm$dInternal.NoInitializer)))(editableKeys1 => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))([])(editableKeys1)))(keys1 => Specular$dInternal$dRIO.bindImpl(() => (
      {value: Data$dMap$dInternal.Leaf}
    ))(context => {
      const m = {name: opts.name, items, init, context, editableKeys: editableKeys1, keys: keys1};
      return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeDyn_({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost
      })(ks => {
        const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(items._1);
        return () => {
          const items$p = $0();
          const newItems = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect)(key1 => {
            const v = Data$dMap$dInternal.lookup(dictOrd)(key1)(items$p);
            if (v.tag === "Just") { return () => Data$dMap$dInternal.Leaf; }
            if (v.tag === "Nothing") {
              const $1 = makeItem(dictShow)(dictAddContext)(m)(key1);
              return () => {
                const a$p = $1();
                return Data$dMap$dInternal.$$$Map("Two", Data$dMap$dInternal.Leaf, key1, a$p, Data$dMap$dInternal.Leaf);
              };
            }
            $runtime.fail();
          })(ks)();
          const $1 = newItems.length === 0;
          const $2 = items._2(v => Data$dMap$dInternal.unionWith(dictOrd)(Data$dFunction.const)(Data$dFoldable.foldlArray(Data$dMap$dInternal.union(dictOrd))(Data$dMap$dInternal.Leaf)(newItems))(v));
          if (!$1) { return $2(); }
          if ($1) { return; }
          $runtime.fail();
        };
      })(Specular$dFRP$dBase.bindDynamic.bind(keys1._1)(x => x)))(() => Specular$dInternal$dRIO.pureImpl({
        field: m,
        init: v => initializer => () => init.value = parent => opts1 => key1 => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)((() => {
          const n = Specular$dInternal$dIncremental.constant(true);
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        })()))(presentWhen_ => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts1))(v1 => {
          const item1 = {parent, key: key1, subform: v1.field, cleanup: () => {}, presentWhen: presentWhen_};
          return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dHost.liftHost(Specular$dFRP$dHost.monadCleanupHost)(Specular$dInternal$dRIO.monadEffectRIO)(v1.init(Restaumatic$dForm$dInternal.NoInitialValue)(dictTypeEquals.proof(a => a)(initializer).item(item1))))(() => Specular$dInternal$dRIO.pureImpl(item1));
        }))
      }));
    })))))
  }
);
const keys = v => v1 => v1.keys._2(_old => v);
const keyOptions = v => v1 => v1.editableKeys.options._2(_old => v);
const key = v => v.key;
const itemForKey = dictOrd => v => k => Specular$dFRP$dBase.functorDynamic.map(v1 => Data$dMap$dInternal.lookup(dictOrd)(k)(v1))(v.items._1);
const item = dictMakeEmpty => v => v1 => Specular$dInternal$dRIO.bindImpl((() => {
  const $0 = v1.init;
  return () => $0.value = parent => opts => key1 => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)((() => {
    const n = Specular$dInternal$dIncremental.constant(true);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })()))(presentWhen_ => Specular$dInternal$dRIO.bindImpl(dictMakeEmpty.makeEmptyImpl(opts))(subform1 => {
    const item1 = {parent, key: key1, subform: subform1, cleanup: () => {}, presentWhen: presentWhen_};
    return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dHost.liftHost(Specular$dFRP$dHost.monadCleanupHost)(Specular$dInternal$dRIO.monadEffectRIO)(v(item1)))(() => Specular$dInternal$dRIO.pureImpl(item1));
  }));
})())(() => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v1.items._1))(items => Data$dList$dTypes.foldableList.foldr(x => {
  const $0 = v(x);
  return b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl(v$1 => x$1 => x$1)($0))(b);
})(Specular$dInternal$dRIO.pureImpl())(Data$dMap$dInternal.values(items))));
const isSelectFieldMappingItem = dictIsSelectField => (
  {
    selectWriteValue: f => dictIsSelectField.selectWriteValue(f.subform),
    selectReadValue: f => dictIsSelectField.selectReadValue(f.subform),
    selectGetOptions: f => dictIsSelectField.selectGetOptions(f.subform),
    selectTouch: f => dictIsSelectField.selectTouch(f.subform)
  }
);
const hasFieldItem = dictHasField => ({getField: label => v => dictHasField.getField(label)(v.subform)});
const hasErrorsWithExtra = dictHasErrors => ({displayedErrors: f => dictHasErrors.displayedErrors(f.subform)});
const eqItem = {eq: Unsafe$dReference.reallyUnsafeRefEq};
const ensureItems = dictOrd => dictShow => dictAddContext => v => keys1 => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.items._1);
  return () => {
    const items$p = $0();
    const a$p = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect)(v1 => {
      const v2 = Data$dMap$dInternal.lookup(dictOrd)(v1._1)(items$p);
      const $1 = (() => {
        if (v2.tag === "Just") { return () => Data$dTuple.$Tuple(v2._1, Data$dMaybe.Nothing); }
        if (v2.tag === "Nothing") {
          const $1 = makeItem(dictShow)(dictAddContext)(v)(v1._1);
          return () => {
            const item1 = $1();
            return Data$dTuple.$Tuple(item1, Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple(v1._1, item1)));
          };
        }
        $runtime.fail();
      })();
      return () => {
        const v2$1 = $1();
        v1._2(v2$1._1)();
        return v2$1._2;
      };
    })(keys1)();
    const newItems = Data$dArray.mapMaybe(x => x)(a$p);
    const $1 = newItems.length === 0;
    const $2 = v.items._2(oldItems => Data$dFoldable.foldlArray(m => v1 => Data$dMap$dInternal.insert(dictOrd)(v1._1)(v1._2)(m))(oldItems)(newItems));
    if (!$1) { return $2(); }
    if ($1) { return; }
    $runtime.fail();
  };
};
const makeEmpty = dictOrd => dictShow => dictAddContext => dictMakeEmpty => (
  {
    makeEmptyImpl: opts => {
      const $0 = Specular$dFRP$dHost.runHost(Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Data$dMap$dInternal.Leaf))(items => Specular$dInternal$dRIO.bindImpl(() => (
        {
          value: parent => opts1 => key1 => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)((() => {
            const n = Specular$dInternal$dIncremental.constant(true);
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })()))(presentWhen_ => Specular$dInternal$dRIO.bindImpl(dictMakeEmpty.makeEmptyImpl(opts1))(subform1 => Specular$dInternal$dRIO.pureImpl({
            parent,
            key: key1,
            subform: subform1,
            cleanup: () => {},
            presentWhen: presentWhen_
          })))
        }
      ))(init => Specular$dInternal$dRIO.bindImpl(Restaumatic$dForm$dInternal.make({
        MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
        MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost
      })({
        makeImpl: Restaumatic$dForm$dInternal.makeWithInitialValueIniti({
          makeImpl: Restaumatic$dForm$dInternal.makeWithDefaultInitializer(Restaumatic$dForm$dFormField.initializeSomeInitialValu1(Restaumatic$dForm$dTotality.isTotalityPartial)(Type$dEquality.refl)(Type$dEquality.refl))([])
        }).makeWithInitialValueInitializer
      })(v => Restaumatic$dForm$dInternal.$InitialValueInitializer([], Restaumatic$dForm$dInternal.NoInitializer)))(editableKeys1 => Specular$dInternal$dRIO.bindImpl(Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO)(Restaumatic$dForm$dInternal.queryLaxWithDefault(Restaumatic$dForm$dFormField.queryFormField$p1(Type$dEquality.refl))([])(editableKeys1)))(keys1 => Specular$dInternal$dRIO.bindImpl(() => (
        {value: Data$dMap$dInternal.Leaf}
      ))(context => {
        const m = {name: opts.name, items, init, context, editableKeys: editableKeys1, keys: keys1};
        return Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.subscribeDyn_({
          MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
          MonadCleanup1: () => Specular$dFRP$dHost.monadCleanupHost
        })(ks => ensureItems(dictOrd)(dictShow)(dictAddContext)(m)(Data$dFunctor.arrayMap(k => Data$dTuple.$Tuple(k, v => () => {}))(ks)))(Specular$dFRP$dBase.bindDynamic.bind(keys1._1)(x => x)))(() => Specular$dInternal$dRIO.pureImpl(m));
      }))))));
      return () => {
        const a$p = $0();
        return a$p._1;
      };
    }
  }
);
const mergeMapMapping = dictOrd => dictShow => dictMerge => dictAddContext => (
  {
    merge: m => v => {
      const $0 = ensureItems(dictOrd)(dictShow)(dictAddContext)(v)(Data$dFunctor.arrayMap(v1 => Data$dTuple.$Tuple(
        v1._1,
        (() => {
          const $0 = v1._2;
          return v$1 => dictMerge.merge($0)(v$1.subform);
        })()
      ))(Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(m)));
      return () => {
        $0();
        return Restaumatic$dForm$dFormField.mergeFormField$p(Type$dEquality.refl).merge(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)(Data$dMap$dInternal.functorMap.map(v$1 => {})(m)))(v.editableKeys)();
      };
    }
  }
);
const mergeSMapMapping = dictOrd => dictShow => dictMerge => dictAddContext => ({merge: m => ff => mergeMapMapping(dictOrd)(dictShow)(dictMerge)(dictAddContext).merge(m)(ff)});
const editableKeys = v => v.editableKeys;
const dumpStateMapping = dictEncodeWithOptions => dictDumpState => (
  {
    dumpState: v => Specular$dFRP$dBase.bindDynamic.bind(v.items._1)(items => Specular$dFRP$dBase.functorDynamic.map(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "items"
    })((() => {
      const $0 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "subform"
      })({encodeWithOptions: v$1 => Foreign$dGeneric$dClass.foreignEncode.encode}))({reflectSymbol: () => "key"})(dictEncodeWithOptions).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
      return {encodeWithOptions: v$1 => $0};
    })()).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))(Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordSingle({
      reflectSymbol: () => "items"
    })()(Specular$dFRP$dBase.functorDynamic)()())({
      items: Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic)(v1 => Record$dExtra.sequenceRecord()(Record$dExtra.sequenceRecordCons({
        reflectSymbol: () => "key"
      })()(Specular$dFRP$dBase.applyDynamic)(Record$dExtra.sequenceRecordSingle({reflectSymbol: () => "subform"})()(Specular$dFRP$dBase.functorDynamic)()())()())({
        key: (() => {
          const $0 = v1.key;
          return (() => {
            const n = Specular$dInternal$dIncremental.constant($0);
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })();
        })(),
        subform: dictDumpState.dumpState(v1.subform)
      }))(Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr)(items))
    })))
  }
);
const displayedItems = dictOrd => v => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => Data$dArray.mapMaybe(k => Data$dMap$dInternal.lookup(dictOrd)(k)(v1))(v2))(v.items._1))(Specular$dFRP$dBase.bindDynamic.bind(v.keys._1)(x => x));
const displayWithIndex = dictOrd => dictMonadFRP => dictMonadReplace => l => renderItem => Specular$dFRP$dList.dynamicListWithIndex_(dictMonadFRP)(dictMonadReplace)(displayedItems(dictOrd)(l))(ix => ditem => Specular$dFRP$dReplaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(ditem)(renderItem((() => {
  const n = Specular$dInternal$dIncremental.constant(ix);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})())));
const displayKey = dictOrd => dictMonadFRP => dictMonadReplace => ff => k => display1 => Specular$dFRP$dExtra.withUniqDynamic_(dictMonadFRP)(dictMonadReplace)({
  eq: x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return Unsafe$dReference.reallyUnsafeRefEq(x._1)(y._1); }
      return false;
    }
    return false;
  }
})(Specular$dFRP$dBase.functorDynamic.map(v1 => Data$dMap$dInternal.lookup(dictOrd)(k)(v1))(ff.items._1))((() => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Applicative0();
  const $1 = $0.Apply0();
  const $2 = $0.pure();
  return v1 => {
    if (v1.tag === "Nothing") { return $2; }
    if (v1.tag === "Just") { return $1.apply($1.Functor0().map(v => x => x)(display1(v1._1)))($2); }
    $runtime.fail();
  };
})());
const display = dictOrd => dictMonadFRP => dictMonadReplace => l => renderItem => Specular$dFRP$dExtra.withUniqDynamic_(dictMonadFRP)(dictMonadReplace)({
  eq: Data$dEq.eqArrayImpl(Unsafe$dReference.reallyUnsafeRefEq)
})(displayedItems(dictOrd)(l))((() => {
  const $0 = dictMonadFRP.MonadCleanup1().Monad0().Applicative0();
  return Data$dFoldable.foldrArray((() => {
    const $1 = $0.Apply0();
    return x => {
      const $2 = renderItem(x);
      return b => $1.apply($1.Functor0().map(v => x$1 => x$1)($2))(b);
    };
  })())($0.pure());
})());
const deleteItem = dictEq => v => Restaumatic$dForm$dFormField.modifyValidValue(v.parent.editableKeys)(x => {
  const $0 = (() => {
    if (x.tag === "Nothing") { return []; }
    if (x.tag === "Just") { return x._1; }
    $runtime.fail();
  })();
  const $1 = Data$dArray.findIndex(dictEq.eq(v.key))($0);
  const $2 = (() => {
    if ($1.tag === "Just") { return Data$dArray.deleteAt($1._1)($0); }
    if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })();
  if ($2.tag === "Nothing") { return $0; }
  if ($2.tag === "Just") { return $2._1; }
  $runtime.fail();
});
const deleteItemCb = dictEq => item1 => deleteItem(dictEq)(item1);
const addItem = dictAddContext => dictOrd => dictShow => v => key1 => {
  const $0 = makeItem(dictShow)(dictAddContext)(v)(key1);
  return () => {
    const item1 = $0();
    v.items._2(Data$dMap$dInternal.insert(dictOrd)(key1)(item1))();
    Restaumatic$dForm$dFormField.modifyValidValue(v.editableKeys)(x => Data$dSemigroup.concatArray((() => {
      if (x.tag === "Nothing") { return []; }
      if (x.tag === "Just") { return x._1; }
      $runtime.fail();
    })())([key1]))();
    return item1;
  };
};
const addContextMapping = dictAddContext => (
  {
    addContext: ctx => v => {
      const $0 = v.context;
      return () => {
        const $1 = $0.value;
        $0.value = Data$dMap$dInternal.unionWith(Data$dOrd.ordInt)(Data$dFunction.const)(ctx)($1);
        const items = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.items._1)();
        return Data$dList$dTypes.foldableList.foldr(x => {
          const $2 = dictAddContext.addContext(ctx)(x.subform);
          return b => () => {
            $2();
            return b();
          };
        })(() => {})(Data$dMap$dInternal.values(items))();
      };
    }
  }
);
export {
  Item,
  Mapping,
  addContextMapping,
  addItem,
  deleteItem,
  deleteItemCb,
  display,
  displayKey,
  displayWithIndex,
  displayedItems,
  dumpStateMapping,
  editableKeys,
  ensureItems,
  eqItem,
  hasErrorsWithExtra,
  hasFieldIdItem,
  hasFieldIdMapping,
  hasFieldItem,
  initializeInitialValueIni,
  initializeNoInitialValueR,
  initializeNoInitializerMa,
  initializeSomeInitialValu,
  isSelectFieldMappingItem,
  item,
  itemForKey,
  key,
  keyOptions,
  keys,
  makeEmpty,
  makeItem,
  mergeItem,
  mergeMapMapping,
  mergeSMapMapping,
  newtypeItem,
  newtypeMapping,
  presentWhen,
  queryArrayTupleMapping,
  queryArrayTupleMapping1,
  queryItem,
  queryItem1,
  queryMapMapping,
  queryMapMapping1,
  querySerializedMapMapping,
  querySerializedMapMapping1,
  subform
};
